import axios from 'axios';
import paths from './paths';
import {
  DistributionListGroup,
  DistributionListGroupCreationRequest,
  DistributionListGroupResponse,
  DistributionListGroupUpdateRequest,
  toDistributionListGroup,
} from '../models/distributionListGroup';
import { BrandCode } from '../../../shared/model/brand.model';


const api = {
  fetchDistributionListGroups: async (): Promise<DistributionListGroup[]> => {
    const response = await axios.get<DistributionListGroupResponse[]>(paths.getDistributionListGroups());
    return response.data.map(toDistributionListGroup);
  },
  fetchDistributionListGroupsByStoreLocation: async (
    code: BrandCode,
    regionDescription: string,
    countryCode: string
  ): Promise<DistributionListGroup[]> => {
    const response = await axios.get<DistributionListGroupResponse[]>(
      paths.getDistributionListGroupsByBrandAndRegionAndCountry(code, regionDescription, countryCode)
    );
    return response.data.map(toDistributionListGroup);
  },
  createDistributionListGroups: async (
    request: DistributionListGroupCreationRequest
  ): Promise<DistributionListGroup> => {
    const response = await axios.post<DistributionListGroupResponse>(paths.postDistributionListGroup(), request);
    return toDistributionListGroup(response.data);
  },
  updateDistributionListGroup: async (
    id: string,
    request: DistributionListGroupUpdateRequest
  ): Promise<DistributionListGroup> => {
    const response = await axios.put<DistributionListGroupResponse>(paths.putDistributionListGroup(id), request);
    return toDistributionListGroup(response.data);
  },
  deleteDistributionListGroup: async (id: string): Promise<void> => {
    const response = await axios.delete<void>(paths.deleteDistributionListGroup(id));
    return response.data;
  },
};

export default api;